module.exports = __webpack_public_path__ + "static/img/homepage_example.20a106b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/homepage_example.png
// module id = LdGL
// module chunks = 0